import { render, staticRenderFns } from "./CreateLessonContent.vue?vue&type=template&id=34e6848a&scoped=true&"
import script from "./CreateLessonContent.vue?vue&type=script&lang=ts&"
export * from "./CreateLessonContent.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLessonContent.vue?vue&type=style&index=0&id=34e6848a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e6848a",
  null
  
)

export default component.exports